import { version } from '@hb/shared'
import { initializeApp } from 'firebase/app'
import { getInstallations, getToken } from 'firebase/installations'
import { siteVersions } from './firebaseConfig'

export const app = initializeApp(siteVersions[version].firebaseConfig)
getToken(getInstallations(app), true)
